import {
  GET_ET_DATES,
  GET_ET_MONTHLY_DATES,
  GET_ET_FORTNIGHTLY_DATES,
  SET_MN_SELECTED_LAYER,
  SET_FN_SELECTED_LAYER,
  ON_SLIDE,
  SET_SHOWINFO,
  SELECTED_MENU,
  SELECTED_LAYER,
  ON_SLIDE_LEFT,
  ON_SLIDE_RIGHT,
  HANDLE_DATE_CHANGE,
  ON_MAP_CLICK,
  GET_ET_ERROR,
  FETCH_REQUEST,
  TOGGLE_VISIBLE_GRAPH,
  TOGGLE_SELECTED_NODE_STATUS,
  SET_LEGEND,
  SIDEBAR_TOGGLE,
  EB_POPUP,
  TECHNICAL_NOTE_TOGGLE,
  DISCLAIMER_TOGGLE,
  WB_POPUP,
  DIALOG_TOGGLE,
  WIDTH_UPDATE,
  INLINE_MODE_CHANGE
} from "../types";
const initialState = {
  dates: [],
  monthly_dates: [],
  monthly_yrs: [],
  fortnightly_dates: [],
  fortnightly_yrs: [],

  mn_selectedLayer:"",
  fn_selectedLayer:"",
  
  date: "",
  inlinemode:false,
  visible: true,
  legend: null,
  slideTracker: -1,
  loading: true,
  visibleGraphPanel: false,
  legendVisible: false,
  chartData: null,
  latlng: null,
  pointInfo: null,
  technicalnoteenable: false,
  disclaimerenable: false,
  selectedLayer: {},
  selectedMenu: null,
  width: 420,
  height: 300,
  x: (window.innerWidth-270-800)/2,
  y: window.innerHeight - 460,
  selectedNodeStatus: {},
  technicalnote: false,
  disclaimer: false,
  EB_popup: false,
  WB_popup: false,
  inlineclose:true,
  
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_SHOWINFO:
      return {
        ...state,
        showInfo: action.payload,
      };
      case INLINE_MODE_CHANGE:return{
        ...state,
        inlinemode:true,
      }
      case WIDTH_UPDATE:return{
        ...state,
        visible:false,
        legendVisible:false,
        x:0,
        y:0,
        width:300,
        height:300
      }
    case GET_ET_DATES:
      return {
        ...state,
        dates: action.payload,
        slideTracker: action.slideTracker,
        date: action.date,
        loading: false,
      };

    case GET_ET_MONTHLY_DATES:
      return {
        ...state,
        monthly_dates: action.payload,
        monthly_yrs: action.years,        
      };

    case SET_MN_SELECTED_LAYER:
      return {
        ...state,
        mn_selectedLayer: action.layername,
      };

    case SET_FN_SELECTED_LAYER:
      return {
        ...state,
        fn_selectedLayer: action.layername,
      };

    case GET_ET_FORTNIGHTLY_DATES:
      return {
        ...state,
        fortnightly_dates: action.payload,
        fortnightly_yrs: action.years,
      };

    case ON_SLIDE:
      return {
        ...state,
        selectedLayer: action.selectedLayer,
        slideTracker: action.payload,
        visibleGraphPanel: false,
        legendVisible: true,
        showInfo:false,
        chartData: null,
        latlng: null,
        pointInfo: null,
      };
    case SELECTED_MENU:
      return {
        ...state,
        selectedMenu: action.payload,
        pointInfo: null,
        technicalnoteenable: false,
        disclaimerenable: false,
      };
    case SELECTED_LAYER:
      return {
        ...state,
        selectedLayer: action.payload,
        chartData: null,
        legendVisible: true,
        visibleGraphPanel: false,
        latlng: null,
      };
    case ON_SLIDE_LEFT:
      return {
        ...state,
        selectedLayer: action.selectedLayer,
        slideTracker: action.payload,
        date: action.date,
        showInfo:false,
        visibleGraphPanel: false,
        legendVisible: true,
        chartData: null,
        latlng: null,
        pointInfo: null,
      };
    case ON_SLIDE_RIGHT:
      return {
        ...state,
        selectedLayer: action.selectedLayer,
        slideTracker: action.payload,
        date: action.date,
        showInfo:false,
        visibleGraphPanel: false,
        legendVisible: true,
        chartData: null,
        latlng: null,
        pointInfo: null,
      };
    case HANDLE_DATE_CHANGE:
      return {
        ...state,
        selectedLayer: action.selectedLayer,
        slideTracker: action.slideTracker,
        inlinemode:false,
        visibleGraphPanel: false,
        legendVisible: true,
        chartData: null,
        latlng: null,
        pointInfo: null,
      };
    case ON_MAP_CLICK:
      return {
        ...state,
        chartData: action.chartData,
        showInfo: action.showInfo,
        // loading:true,
        pointInfo: action.pointInfo,
        visibleGraphPanel: true,
      };
    case GET_ET_ERROR:
      return {
        ...state,
        loading: true,
      };
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        chartData: null,
        visibleGraphPanel: true,
        WB_popup: false,
        EB_popup: false,
        technicalnote: false,
        disclaimer: false,
        // visibleGraphPanel:false,
        latlng: action.latlng,
      };
    case TOGGLE_VISIBLE_GRAPH:
      return {
        ...state,
        visibleGraphPanel: action.visibleGraphPanel,
      };
    case TOGGLE_SELECTED_NODE_STATUS:
      return {
        ...state,
        selectedNodeStatus: action.selectedNodeStatus,
      };
    case SIDEBAR_TOGGLE:
      return {
        ...state,
        visible: action.visible,
      };
    case SET_LEGEND:
      return {
        ...state,
        legend: action.legend,
      };
    case EB_POPUP:
      return {
        ...state,
        EB_popup: action.payload,
        WB_POPUP: false,
        technicalnote: false,
        disclaimer: false,
        visibleGraphPanel: false,
        visible:window.innerWidth>1000?true:false,
      };
    case WB_POPUP:
      return {
        ...state,
        WB_popup: action.payload,
        EB_popup: false,
        technicalnote: false,
        disclaimer: false,
        visibleGraphPanel: false,
      };
    case TECHNICAL_NOTE_TOGGLE:
      return {
        ...state,

        technicalnote: action.payload,
        disclaimer: false,
        visibleGraphPanel: false,
        WB_popup: false,
        EB_popup: false,
        visible:window.innerWidth>1000?true:false,
      };
    case DISCLAIMER_TOGGLE:
      return {
        ...state,
        disclaimer: action.payload,
        technicalnote: false,
        visibleGraphPanel: false,
        WB_popup: false,
        EB_popup: false,
        visible:window.innerWidth>1000?true:false,
      };
    case DIALOG_TOGGLE:
      return {
        ...state,
        technicalnote: false,
        visibleGraphPanel: false,
        WB_popup: false,
        EB_popup: false,
        disclaimer: false,
      };
    default:
      return state;
  }
}
